import React from 'react';
import classnames from 'classnames';
import {FormattedMessage} from 'react-intl';
import {Segment, Header} from 'semantic-ui-react';
import {string, element, oneOfType} from 'prop-types';

const SegmentSectionWrapper = props => (
  <Segment className={classnames('basic-section-wrapper', props.className)}>
    <Header as='h4'>
      {props.headerKey ? <FormattedMessage id={props.headerKey} /> : props.header}
    </Header>
    {props.children}
  </Segment>
);

SegmentSectionWrapper.propTypes = {
  className: string,
  header: oneOfType([string, element]),
  headerKey: string
};

SegmentSectionWrapper.defaultProps = {
  className: '',
  header: ''
};

export default SegmentSectionWrapper;



// WEBPACK FOOTER //
// ./public/components/common/SegmentSectionWrapper.jsx